<template>
  <div class="splitters-list-container mt-4 pl-4 pr-4">
    <div 
      class="pr-6 pl-4 splitters-list-wrapper"
      v-for="(object, index) in list" 
      :key="index"
    >
      <Splitters
        :data="object"
        :fiber-colors="fiberColors"
        :cables="cables"
        :splitters="splitters"
        @open-menu="openMenu"
      />
    </div>
  </div>
</template>
  
<script>
  import Splitters from './Splitters.vue';
  export default {
    name: "SplittersList",
    components: {
      Splitters
    },
    props:{
      list: {
        type: Array
      },
      fiberColors: {
        type: Array
      },
      cables: {
        type: Array
      },
      splitters: {
        type: Array
      }
    },
    methods: {
      openMenu(e, splitter, nivel){
        this.$emit('open-menu', e, splitter, nivel);
      }
    }
  };
</script>
<style scoped>
.splitters-list-container{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.splitters-list-wrapper{
  width: 740px;
}
</style>


// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Splicing/SplittersInfo/SplittersList.vue